import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ForecastNotAvailableDesc, PollutionForecastBoxColours, PollutionForecastTypes } from 'src/app/models/app-constants';
import { getForecastDateDescription, getPollutionForecastDescText } from 'src/app/shared/utils';

@Component({
	selector: 'app-water-quality-forecast',
	templateUrl: './water-quality-forecast.component.html',
	styleUrls: ['./water-quality-forecast.component.scss'],
})
export class WaterQualityForecastComponent implements OnInit, OnChanges {
	@Input() pollutionForecast : string;
	@Input() pollutionDescription : string;
	@Input() pollutionForecastDate : Date | undefined = new Date();	
	@Input() patrolDescription : string = "";

	public pollLevelIndicatorIcon : string = PollutionForecastBoxColours[PollutionForecastTypes.DATA_UNAVAILABLE]["icon"]?.toString() ?? "Unavailable.svg";

	boxBackgroundColour : string = PollutionForecastBoxColours[PollutionForecastTypes.DATA_UNAVAILABLE]["boxBackgroundColor"]?.toString() ?? "#FFFFFF";
	titleBlockBackgroundColour : string = PollutionForecastBoxColours[PollutionForecastTypes.DATA_UNAVAILABLE]["titleBlockBackgroundColor"]?.toString() ?? "#FFFFFF";
	titleBlockTextColour : string = PollutionForecastBoxColours[PollutionForecastTypes.DATA_UNAVAILABLE]["titleBlockTextColor"]?.toString() ?? "#000000";

	ngOnInit() : void {
		
	}


	ngOnChanges(changes: SimpleChanges): void {
		if(changes["pollutionForecast"])
		{
			const forecast = changes["pollutionForecast"].currentValue;	
			
			if(forecast)
			{
				const item = PollutionForecastBoxColours[<string>forecast];
				if(item)
				{
					this.pollLevelIndicatorIcon = item["icon"]?.toString();
					this.boxBackgroundColour = item["boxBackgroundColor"]?.toString();
					this.titleBlockBackgroundColour = item["titleBlockBackgroundColor"]?.toString();
					this.titleBlockTextColour = item["titleBlockTextColor"]?.toString();
				}				
			}			
		}	
	}


	get forecastClass(): string {
		switch (this.pollutionForecast) {
		case PollutionForecastTypes.POLLUTION_LIKELY:
			return 'water-quality-forecast-pollution-likely';
		case PollutionForecastTypes.POLLUTION_UNLIKELY:
			return 'water-quality-forecast-pollution-unlikely';
		case PollutionForecastTypes.POLLUTION_POSSIBLE:
			return 'water-quality-forecast-pollution-possible';
		default:
			return 'water-quality-forecast-unavailable';
		}
	}

	get forecastBriefDesc(): string {
		return getForecastDateDescription(this.pollutionForecastDate!);

		// if (!this.pollutionForecastDate &&
		// 	"function" === typeof (this.pollutionForecastDate!.getTime) &&
		// 	"Invalid Date" !== this.pollutionForecastDate!.toString()) 
		// {
		// 	return "Forecast for " + getForecastDateDescription(this.pollutionForecastDate!);
		// }
		// else
		// {
		// 	return ForecastNotAvailableDesc;
		// }		
	}	

	get forecastIcon() : string {
		switch (this.pollutionForecast) 
		{
			case PollutionForecastTypes.POLLUTION_LIKELY:
				return 'water-quality-forecast-pollution-likely';
			case PollutionForecastTypes.POLLUTION_UNLIKELY:
				return 'water-quality-forecast-pollution-unlikely';
			case PollutionForecastTypes.POLLUTION_POSSIBLE:
				return 'water-quality-forecast-pollution-possible';
			default:
				return 'water-quality-forecast-unavailable';
		}
	}
	
	get pollutionForecastText() 
	{
		return getPollutionForecastDescText(this.pollutionForecast);		
	}
}
